export const smoothScroll = (event: Event, id: string) => {
  event.preventDefault();
  event.stopPropagation();
  const offset = 100;
  const element = document.getElementById(id);
  if (!element) {
    console.warn(`Element with id ${id} not found`);
    return false;
  }
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
  return false;
};
